/* Niroza: open the product page from the range cards and the closer-look packs.

   A drop-in for a theme whose home section predates these links. The product
   handle is already in the markup (data-product on each WhatsApp/Amazon link),
   so nothing needs to be configured. Newer builds of the section carry the same
   links in the markup and simply do not load this file. */
(function () {
  "use strict";
  var doc = document;
  var LABEL = "Full details and how to take it";

  function productUrl(handle) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    return root.replace(/\/$/, "") + "/products/" + handle;
  }

  function link(cls, href) {
    var a = doc.createElement("a");
    a.className = cls;
    a.href = href;
    a.textContent = LABEL;
    a.insertAdjacentHTML("beforeend",
      '<svg class="nz-ico" aria-hidden="true"><use href="#nz-i-arrow"/></svg>');
    return a;
  }

  function handleOf(el) {
    var tagged = el.querySelector("[data-product]");
    return tagged && tagged.dataset.product;
  }

  function apply(scope) {
    (scope || doc).querySelectorAll(".nz-card").forEach(function (card) {
      if (card.__nzLinked) return;
      var handle = handleOf(card);
      if (!handle) return;
      card.__nzLinked = 1;
      var href = productUrl(handle);

      var media = card.querySelector(".nz-card__media");
      var title = card.querySelector(".nz-card__body h3");
      var name = title ? title.textContent.trim() : "";
      if (media) {
        media.setAttribute("href", href);
        media.setAttribute("aria-label", "See " + name + ": full details, how to take it and what is on the label");
      }
      if (title && !title.querySelector("a")) {
        var a = doc.createElement("a");
        a.className = "nz-card__title";
        a.href = href;
        a.textContent = name;
        title.textContent = "";
        title.appendChild(a);
      }
      var buy = card.querySelector(".nz-card__buy");
      if (buy && !card.querySelector(".nz-card__more")) buy.parentNode.insertBefore(link("nz-card__more", href), buy);
    });

    (scope || doc).querySelectorAll(".nz-step").forEach(function (step) {
      if (step.__nzLinked) return;
      var handle = handleOf(step);
      if (!handle) return;
      step.__nzLinked = 1;
      var buy = step.querySelector(".nz-step__buy");
      if (buy && !step.querySelector(".nz-step__more")) {
        buy.parentNode.insertBefore(link("nz-card__more nz-step__more", productUrl(handle)), buy);
      }
    });
  }

  if (doc.readyState === "loading") doc.addEventListener("DOMContentLoaded", function () { apply(); });
  else apply();
  doc.addEventListener("shopify:section:load", function (e) { apply(e.target); });
})();
